import { render, staticRenderFns } from "./SectionMenuWorkspace.vue?vue&type=template&id=8c1473a2&scoped=true&"
import script from "./SectionMenuWorkspace.vue?vue&type=script&lang=js&"
export * from "./SectionMenuWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuWorkspace.vue?vue&type=style&index=0&id=8c1473a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1473a2",
  null
  
)

export default component.exports